<template>
    <Wrapper>
        <a id="main-content" class="fixed top-0" tabindex="-1"></a>

        <Breadcrumb :items="breadcrumbItems" />

        <div class="grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12 lg:col-span-7">
                <h1 class="header-1 mb-4">
                    {{ model.name }}
                </h1>
            </div>
            <div v-if="model.components" class="col-span-12 lg:col-span-8 lg:col-start-2">
                <EditableContentComponentGroup :components="model.components" has-parent-container />
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import EditableContentComponentGroup from '@/components/Generic/EditableContentComponentGroup.vue';

export default {
    name: 'PublicInterestData',
    components: {
        EditableContentComponentGroup,
        Wrapper,
    },
    async asyncData({ $axios, params, redirect, localePath, i18n }) {
        let model = null;

        await $axios
            .$get(`/public-information/by-slug/${params.data}`)
            .then((res) => {
                model = res;
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return await redirect(307, localePath('public-information'));
        }

        await i18n.generateLocalizedRouteParams(model.locale_variants, 'data');

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('public_information.title'), 'public-information']);
        breadcrumbItems.push([model.name, 'data']);

        return {
            breadcrumbItems,
            model,
        };
    },
    head() {
        return {
            title: this.$getPageTitle(this.model.metadata),
            meta: this.$getPageMetaData(this.model.metadata),
        };
    },
};
</script>

<style scoped></style>
